export default __webpack_public_path__ + "static/media/sanmat12.48e3963c.jpg";